import Upload from './Upload.vue'

export default Upload
